import React from "react";

export const MariaMother = ({size = 20, ...props}) => {
	return (
		<svg
			height={size}
			viewBox="0 0 512 512"
			width={size}
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M255.403 224.778c-9.466 0-19.074-1.2-28.648-3.715-29.135-7.651-53.526-26.174-68.679-52.156-15.111-25.909-19.219-56.143-11.57-85.133 15.811-59.917 77.535-95.832 137.588-80.061 29.135 7.651 53.526 26.174 68.679 52.156 15.111 25.909 19.219 56.143 11.57 85.133-13.292 50.366-59.03 83.776-108.94 83.776zm.038-209.553c-43.173 0-82.722 28.882-94.215 72.436-6.612 25.054-3.06 51.184 10 73.578 13.103 22.466 34.197 38.483 59.397 45.101 51.943 13.637 105.327-17.411 119-69.222 6.612-25.054 3.061-51.184-10-73.578-13.103-22.466-34.197-38.483-59.397-45.101a97.447 97.447 0 00-24.785-3.214zM356.983 139.06h.01z"
				fill="#ffda33"
			/>
			<path d="M192 175.886h126.75v277.016H192z" fill="#ff525a" />
			<path
				d="M256.064 194.985h-.129c-24.046 0-43.539-19.333-43.539-43.182V105.41h87.208v46.394c-.001 23.848-19.494 43.181-43.54 43.181z"
				fill="#fff4c7"
			/>
			<path
				d="M212.438 89.224v43.803c19.452 0 30.878-8.602 37.549-17.902 2.953-4.117 9.139-4.117 12.09 0 6.67 9.3 18.096 17.902 37.549 17.902V89.224z"
				fill="#f7b681"
			/>
			<path
				d="M256 51.223c-39.828 0-75.054 27.418-75.054 71.983l.135 74.231a30.488 30.488 0 01-3.569 14.358c-15.465 29.105-23.664 46.677-23.664 81.804v111.727c0 22.576 18.302 40.878 40.878 40.878l-.545-28.072c-.198-10.198 8.014-18.571 18.214-18.571V115.595c0-14.565 11.836-26.372 26.436-26.372h34.336c14.6 0 26.436 11.807 26.436 26.372V399.56c10.675.353 19.146 9.108 19.146 19.789v26.854c21.761 0 39.401-17.641 39.401-39.401V293.599c0-35.342-8.114-52.579-23.675-81.831a30.286 30.286 0 01-3.554-14.285c.044-21.81.132-56.049.132-74.277.001-44.565-35.225-71.983-75.053-71.983z"
				fill="#ade0ed"
			/>
			<path
				d="M334.476 211.768a30.283 30.283 0 01-3.554-14.285c.044-21.81.132-56.049.132-74.277 0-44.565-35.226-71.983-75.054-71.983-10.503 0-20.686 1.907-29.988 5.532 15.814 6.164 29.08 17.295 37.037 32.468h10.119c14.6 0 26.436 11.807 26.436 26.372V399.56c10.675.353 19.146 9.108 19.146 19.789v26.854c21.761 0 39.401-17.64 39.401-39.401V293.599c0-35.342-8.114-52.579-23.675-81.831z"
				fill="#8fd8eb"
			/>
			<path
				d="M193.822 274.137l47.836-33.164v40.833l-46.692 32.812z"
				fill="#ade0ed"
			/>
			<path
				d="M318.75 274.137l-47.837-33.164v40.833l46.693 32.812z"
				fill="#8fd8eb"
			/>
			<g fill="#fff4c7">
				<path d="M270.755 282.661c9.652 0 16.711-9.085 14.303-18.409l-10.318-39.964a9.524 9.524 0 00-9.227-7.134c-5.262 0-9.528 4.256-9.528 9.505v41.269c0 8.137 6.613 14.733 14.77 14.733zM241.215 282.661c-9.652 0-16.711-9.085-14.303-18.409l10.318-39.964a9.524 9.524 0 019.227-7.134c5.262 0 9.528 4.256 9.528 9.505v41.269c0 8.137-6.612 14.733-14.77 14.733z" />
			</g>
			<path
				d="M345.299 477v-20.647c0-5.605-4.544-10.149-10.149-10.149h-158.3c-5.605 0-10.149 4.544-10.149 10.149V477h-12.666c-5.605 0-10.149 4.544-10.149 10.149V512h224.226v-24.851c0-5.605-4.544-10.149-10.149-10.149z"
				fill="#85667d"
			/>
			<path
				d="M357.964 477h-12.666v-20.647c0-5.605-4.544-10.149-10.149-10.149h-50.744c5.605 0 10.149 4.544 10.149 10.149V477h12.666c5.605 0 10.149 4.544 10.149 10.149V512h50.744v-24.851c0-5.605-4.544-10.149-10.149-10.149z"
				fill="#7d5c75"
			/>
			<g fill="#6e5167">
				<path d="M345.298 469.389h-95.619c-4.204 0-7.612 3.407-7.612 7.612s3.407 7.612 7.612 7.612h95.619c4.204 0 7.612-3.407 7.612-7.612s-3.408-7.612-7.612-7.612zM206.053 469.389h-39.352c-4.204 0-7.612 3.407-7.612 7.612s3.407 7.612 7.612 7.612h39.352c4.204 0 7.612-3.407 7.612-7.612s-3.407-7.612-7.612-7.612z" />
			</g>
			<g fill="#d5e8ed">
				<path d="M384.398 177.36a7.613 7.613 0 01-5.383-12.994l54.712-54.711a7.613 7.613 0 0110.765 10.765l-54.712 54.711a7.587 7.587 0 01-5.382 2.229zM477.675 219.529h-77.131a7.611 7.611 0 01-7.612-7.612 7.611 7.611 0 017.612-7.612h77.131c4.204 0 7.612 3.407 7.612 7.612s-3.407 7.612-7.612 7.612zM127.602 177.36a7.591 7.591 0 01-5.383-2.229L67.508 120.42a7.613 7.613 0 0110.765-10.765l54.712 54.711a7.613 7.613 0 01-5.383 12.994zM111.456 219.529H34.325a7.611 7.611 0 01-7.612-7.612 7.611 7.611 0 017.612-7.612h77.131c4.204 0 7.612 3.407 7.612 7.612s-3.408 7.612-7.612 7.612z" />
			</g>
		</svg>
	);
}

export default MariaMother;
